import type { App, Directive, DirectiveBinding } from 'vue';
import { useUserStore } from '@/store/modules/user';

const hasPermission = (value: string): boolean => {
  const userStore = useUserStore();
  const permission = (userStore?.buttonList.map((m) => m.url) || []) as string[];
  if (!value) {
    throw new Error('请设置操作权限值');
  }
  if (permission.includes(value)) {
    return true;
  }
  return false;
};
function hasPermi(el: Element, binding: DirectiveBinding) {
  const value = binding.value;

  const flag = hasPermission(value);
  if (!flag) {
    el.parentNode?.removeChild(el);
  }
}
const mounted = (el: Element, binding: DirectiveBinding<any>) => {
  hasPermi(el, binding);
};

const permiDirective: Directive = {
  mounted,
};

export const setupPermissionDirective = (app: App<Element>) => {
  app.directive('hasPermi', permiDirective);
};

export default permiDirective;
